// Customizable Area Start
import React from "react";
import moment from "moment";
import MessageListView from "./MessageListView";

const MessageList = ({ messages }) => {
  const formatAMPM = (date) => {
    return moment(date).format('hh:mm A')
  };
  
  const viewProps = {
    messages,
    formatAMPM,
  };

  return <MessageListView testID="MessageListView" {...viewProps} />;
};

export default MessageList;
// Customizable Area End
